import { BaseMeasures } from './BaseMeasures.ts';

export const CollabEditProviderMeasures: BaseMeasures = new BaseMeasures();
